import classNames from 'classnames'

const SmallButton = ({children, onClick, className, type = ''}) => {
    return (
        <button
            className={classNames('small-button', {
                [className]: !!className
            })}
            onClick={onClick} type={type}>
            {children}
        </button>
    )
}

export default SmallButton
